function uniq(array) {
  return array.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
}

export default uniq;


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/utils/uniq.js
// module id = null
// module chunks = 